import React from 'react';
import {Typography, Paper} from 'material-ui';
import {withStyles} from 'material-ui/styles';
import PropTypes from 'prop-types';


const style = {
    root:{
        "font-family": "Lobster",
        "color":"rgb(48,48,48)"
    }
}

function parseText(text){
    let parsedText = '';
    parsedText = text.trim();
    parsedText = parsedText.replace(/\/n/g, "<br/>");
    return { __html: parsedText}
}
//{parseText(props.quote.content)}
function QuoteCard(props){

    return (
        <section className="flex flex-auto layout-column overflow-y justify-center">
            <Paper elevation={0}>
                <Typography className="text-center" classes = {{
                    root: props.classes.root
                }}
                paragraph={true} variant="subheading" dangerouslySetInnerHTML={parseText(props.quote.content)} />
            </Paper>
        </section>
    )
}

QuoteCard.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(style)(QuoteCard)


// WEBPACK FOOTER //
// ./src/Components/QuoteCard.js